import React from 'react'
import { css } from '@emotion/react'
import Link from 'next/link'
import { CompanyLogo } from 'plume-ui'
import { isIPO } from '@/lib/company'
import { COMPANY_HREF } from '@/lib/url'
import { CompanyData } from '../../../../types/api'
import { A } from '../../../atoms/A'
import { IPOIcon } from '../../../atoms/icons/IPOIcon'
import { LineClampText } from '../../../atoms/LineClampText'
import { TableCell } from '../../../atoms/Table'
import { TagButton, TagButtonGroup } from '../../../atoms/TagButton'

const MAX_TAGS = 6

export const CompanySummaryCell: React.FC<{
  company: CompanyData
  className?: string
}> = (props) => {
  return (
    <TableCell className={props.className}>
      <div
        css={css`
          display: flex;
        `}
      >
        <div>
          <Link as={props.company.path} href={COMPANY_HREF} passHref>
            <a>
              <CompanyLogo
                src={
                  props.company.imageUrl || '/static/images/default/company.png'
                }
                size="normal"
                name={props.company.name}
              />
            </a>
          </Link>
        </div>
        <div
          css={css`
            flex: 1;
            margin-left: 10px;
          `}
        >
          <div className="company-name">
            <Link as={props.company.path} href={COMPANY_HREF} passHref>
              <A decoration="none">{props.company.name}</A>
            </Link>
            {isIPO(props.company) && (
              <IPOIcon
                css={css`
                  margin-left: 3px;
                `}
              />
            )}
          </div>
          <LineClampText
            justify
            lineNumber={5}
            css={css`
              font-size: 12px;
              line-height: 1.5;
            `}
            stripLineBreaks
          >
            {props.company.description}
          </LineClampText>
          <div
            css={css`
              margin-top: 6px;
            `}
          >
            <TagButtonGroup>
              {props.company.tags.slice(0, MAX_TAGS).map((tag, i) => (
                <TagButton key={i} tag={tag} />
              ))}
              <Ellipsis
                rest={props.company.tags
                  .slice(MAX_TAGS)
                  .map((tag) => `#${tag.name}`)
                  .join(', ')}
              />
            </TagButtonGroup>
          </div>
        </div>
      </div>
    </TableCell>
  )
}

const Ellipsis: React.FC<{ rest: string }> = ({ rest }) => {
  return rest ? (
    <span
      title={rest}
      css={css`
        padding-left: 2px;
        line-height: 1.2;
      `}
    >
      ...
    </span>
  ) : null
}
